export default __webpack_public_path__ + "img/5224e1c04a7d80fec6ae0aa1214c1499.svg";